// Рубли: API биллинга работает в рублях, копейки живут только в БД.
export const TOPUP_PRESETS = [5000, 10000, 15000, 20000, 25000, 30000]

// ЮKassa возвращает на фиксированный return_url без параметров —
// id платежа переносим через сессию сами.
export const PENDING_PAYMENT_KEY = 'billing.pendingPaymentId'

// Как часто перечитывать счёт: вкладку CRM держат открытой сменами, а баланс
// за это время меняется ночным списанием и пополнениями с других устройств.
export const PAYMENT_ACCOUNT_REFRESH_MS = 30 * 60 * 1000
